import { FunctionComponent, useCallback } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { trackEvent } from '@surfline/web-common';
import StarCircle from 'components/Icons/StarCircle';
import PremiumBadgeIcon from 'components/Icons/PremiumBadgeIcon';
import { useMinWidthMobileLarge } from 'hooks/useMediaQueries';
import WavetrakLink from 'components/WavetrakLink';
import config from 'config';

import styles from './DaysToWatchCTA.module.scss';

interface DaysToWatchCTAProps {
  pageName: string;
}

const DaysToWatchCTA: FunctionComponent<DaysToWatchCTAProps> = ({ pageName }) => {
  const isMobile = !useMinWidthMobileLarge();

  const handleClick = useCallback(() => {
    trackEvent('Button Clicked', {
      buttonText: 'View days to watch',
      pageName,
      uiElement: 'days to watch cta',
    });
  }, [pageName]);

  return (
    <WavetrakLink
      href={`${config.surflineHost}/upgrade`}
      isExternal={true}
      onClick={handleClick}
      data-testid="days-to-watch-cta"
      tabIndex={-1}
    >
      <Button
        className={styles.daysToWatchCTA}
        disableFocusRipple
        disableRipple
        disableTouchRipple
        size="small"
        variant="secondary"
      >
        <Stack direction="row" alignItems="center" spacing="10px">
          <StarCircle className={styles.star} />
          <Typography component="span" variant="callout1">
            View days to watch
          </Typography>
          {!isMobile && <PremiumBadgeIcon height="18px" width="16px" />}
        </Stack>
      </Button>
    </WavetrakLink>
  );
};

export default DaysToWatchCTA;
